import { lazy } from "react";
import { getTenant } from "../../../Utils/storageUtils";
import { TenantType } from '../../../Utils/types';

const PBNudgesScreenDashboard = lazy(()=> import('../../PaisaBazaar/NudgesScreenDashboard'));
const AUNudgesScreenDashboard = lazy(()=> import('../../AUBank/NudgesScreenDashboard'));

const NudgesScreenDashboard = ()=>{
    const tenant = getTenant();

    const renderTenantSpecificDashboard = () => {
        switch (tenant) {
          case TenantType.PB:
            return <PBNudgesScreenDashboard/>

            case TenantType.AU:
                return <AUNudgesScreenDashboard/>
    
          case TenantType.JFS:
    
           
    
          case TenantType.YESBANK:
          case TenantType.MAHINDRA:
          default:
            return <></>;
        }
      };
    return(
        <div>
           {renderTenantSpecificDashboard()}
        </div>
    )
}

export default NudgesScreenDashboard;